import z from 'zod';

export const addressSchema = z.object({
  street: z.string().nonempty({ error: 'Street address is required' }),
  city: z.string().nonempty({ error: 'City name is required' }),
  state: z.string().nonempty({ error: 'State name is required' }),
  zipCode: z.string().nonempty({ error: 'Zip code is required' }),
  country: z.string().nonempty({ error: 'Country name is required' }),
});

export type Address = z.infer<typeof addressSchema>;

export const transformAddressToString = (address: Address) =>
  `${address.street}, ${address.city}, ${address.state}, ${address.zipCode}, ${address.country}`;
